import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidatorFn, Validators } from "@angular/forms";

import { FakturaStatus } from "../model/faktura-status.model";
import { FakturagodkendelseModalData } from "../model/fakturagodkendelse-modal-data.model";

export class FakturagodkendelseModalFormBuilder {
    public static opretForm(fakturagodkendelseModalData: FakturagodkendelseModalData): UntypedFormGroup {
        const form = new UntypedFormBuilder().group({
            status: [fakturagodkendelseModalData.status],
            kodeord: [],
            bemaerkning: [fakturagodkendelseModalData.bemaerkning]
        });
        this.updateState(form);
        form.get("status").valueChanges.subscribe(() => {
            this.updateState(form);
        });
        return form;
    }

    private static updateState(form: UntypedFormGroup): void {
        const status = form.get("status").value;
        this.setValidators(form.get("kodeord"), status === FakturaStatus.Afslaaet ? [] : [Validators.required]);
        this.setDisabled(form.get("kodeord"), status === FakturaStatus.Afslaaet);
        this.setDisabled(form.get("bemaerkning"), status === FakturaStatus.Afslaaet);
    }

    private static setDisabled(control: AbstractControl, disabled: boolean): void {
        if (disabled) {
            control.disable();
        } else {
            control.enable();
        }
    }

    private static setValidators(control: AbstractControl, validators: ValidatorFn[]): void {
        control.setValidators(validators);
        control.updateValueAndValidity({ emitEvent: false });
    }
}
